export const EMAIL_TYPES = {
  CONFIRMATION_BOOKING_INVOICE: 'confirmation-booking-invoice',
};
